import { arrayOf } from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

import { brandShape } from '../../prop-types';
import { listColumns } from '../brand-columns';

function List({ data }) {
  return (
    <ReactTable
      columns={listColumns}
      data={data}
      minRows={2}
      showPagination={data.length > 20}
    />
  );
}

List.propTypes = {
  data: arrayOf(brandShape.isRequired),
};

List.defaultProps = {
  data: [],
};

export default List;
